import { ONBOARDING_VIEW_DE, ONBOARDING_VIEW_EN } from './ONBOARDING_VIEW_TRANSLATIONS'
import { REGISTER_VIEW_DE, REGISTER_VIEW_EN } from './REGISTER_VIEW'

/**
 * The combined english translations for all of the onboarding related components
 */
const ONBOARDING_TRANSLATION_EN = Object.assign(REGISTER_VIEW_EN, ONBOARDING_VIEW_EN)
/**
 * The combined german translations for all of the onboarding related components
 */
const ONBOARDING_TRANSLATION_DE = Object.assign(REGISTER_VIEW_DE, ONBOARDING_VIEW_DE)

export { ONBOARDING_TRANSLATION_EN, ONBOARDING_TRANSLATION_DE }
